import React, { Fragment } from 'react';
import Grid from '@mui/material/Grid';

import { Paper } from '@mui/material';

export default function CantFind() {
    return (
        <Fragment>
            <h1>You are unauthorized to view this page</h1>
            <Paper>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    style={{ minHeight: '25vh' }}
                ><Grid item xs={12} md={12} lg={12}>
                        <img src="/a44.gif" alt="These are not the droids" />
                        <br />
                        <br />
                    </Grid>
                </Grid>
            </Paper>
        </Fragment>
    )
}
